import type { VoiceBackground } from '@poseidon/types/svr/voiceBackground.type';

import { api } from '@/utils/api';

/**
 * The rep's remembered Voice Drop background (Off / Office / Office + phone) for the dashboard's
 * voice composers (Take Action, DFY contact page, contact-detail voice card).
 *
 * `change` updates the cached value at once and saves it with one `setVoiceBackground` call, so the
 * choice sticks even if the regeneration that usually follows fails.
 */
export function useVoiceBackground(params: { userId: string | undefined; teamId: string | undefined }) {
  const utils = api.useUtils();
  const enabled = params.userId != null && params.userId !== '' && params.teamId != null && params.teamId !== '';
  const input = { userId: params.userId ?? '', teamId: params.teamId ?? '' };
  const query = api.audioFile.voiceBackground.useQuery(input, { enabled, staleTime: 5 * 60 * 1000 });
  const save = api.audioFile.setVoiceBackground.useMutation();

  const change = (background: VoiceBackground) => {
    if (!enabled) return;
    utils.audioFile.voiceBackground.setData(input, { background });
    save.mutate({ ...input, background });
  };

  return { background: query.data?.background ?? 'off', change };
}
